import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { ClipboardCheck } from 'lucide-react'
import { buttonVariants } from '@quebon/ui/components/button'
import { handheldCoachingHref, type HandheldSelection } from './handheldNavigation'

interface Props {
  selection?: HandheldSelection
}

/** AdminLayout에서 권한·센터 조건을 확인한 뒤 모든 화면 크기에서 공통으로 노출한다. */
export function HandheldCoachingShortcut({ selection = {} }: Props) {
  const { t } = useTranslation('coaching')

  return <>
    <div aria-hidden="true" className="h-[calc(5.5rem+env(safe-area-inset-bottom))] print:hidden" />
    <div className="fixed right-[max(1rem,env(safe-area-inset-right))] bottom-[max(1rem,env(safe-area-inset-bottom))] z-40 print:hidden">
      <Link
        to={handheldCoachingHref(selection)}
        aria-label={t('handheld.quickAccess')}
        className={buttonVariants({ size: 'lg', className: 'min-h-12 gap-2 px-4 shadow-lg' })}
      >
        <ClipboardCheck data-icon="inline-start" aria-hidden="true" />
        {t('handheld.open')}
      </Link>
    </div>
  </>
}
